import { m } from '@aimfora/i18n'
import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import { PageHeader } from '~/components/app-shell'
import { BillingPage } from '~/components/billing/billing-page'
import { SettingsNav } from '~/components/settings-nav'

export const Route = createFileRoute('/_authed/app/settings/billing')({
  // `fake_session` is what the simulated Stripe (development and test only) adds to the return address
  validateSearch: z.object({
    checkout: z.enum(['success', 'cancel']).optional(),
    fake_session: z.string().optional(),
  }),
  head: () => ({ meta: [{ title: `${m.billing_title()} - ${m.app_name()}` }] }),
  component: BillingRoute,
})

function BillingRoute() {
  const { checkout } = Route.useSearch()
  return (
    <>
      <SettingsNav />
      <PageHeader title={m.billing_title()} />
      <BillingPage checkout={checkout} />
    </>
  )
}
